import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getRouters } from '@/api/system/menu'

/**
 * 路由状态管理 Store
 * 用于管理动态路由数据的加载和缓存
 */
export const useRouteStore = defineStore('route', () => {
  /**
   * 路由数据列表
   * @type {ref<Array>}
   */
  const routes = ref([])

  /**
   * 路由是否已加载完成
   * @type {ref<boolean>}
   */
  const isRoutesLoaded = ref(false)

  /**
   * 设置路由数据
   * @param {Array} newRoutes - 新的路由数组
   */
  const setRoutes = (newRoutes) => {
    routes.value = newRoutes
    isRoutesLoaded.value = true
  }

  /**
   * 从后端加载路由数据
   * 调用接口获取菜单路由配置
   * @returns {Promise<Array>} 路由数组
   */
  const loadRoutes = async () => {
    const response = await getRouters()
    setRoutes(response.data || [])
    return response.data || []
  }

  /**
   * 重置路由数据
   * 清空已加载的路由并重置加载状态
   */
  const resetRoutes = () => {
    routes.value = []
    isRoutesLoaded.value = false
  }

  return {
    routes,
    isRoutesLoaded,
    setRoutes,
    loadRoutes,
    resetRoutes
  }
}, {
  persist: true
})
